<template lang="pug">
ExtLink.parts-header-sign-in(
  :external="external"
  :to="to"
)
  slot {{ text }}
</template>

<script>
import ExtLink from '@/components/ext/Link.vue';

export default {
  components: {
    ExtLink,
  },
  
  props: {
  	to: {
      type: [String, Object],
    },

  	text: {
      type: String,
      default: '',
    },

    external: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.parts-header-sign-in {
  color: #90969d;
  text-decoration: none;
  text-transform: uppercase;

  &:hover {
    text-decoration: none;
    color: #51acff;
  }
}
</style>



// WEBPACK FOOTER //
// SignLink.vue?2da1f43b